export default __webpack_public_path__ + "static/media/dhl_aviation@2x.894408e1.png";